import React from 'react';
import styled from 'styled-components';
import { colors as colors99dUi } from '@99designs/emu/settings';
import LeftArrow from '../../../shared/components/Icon/components/Left4';
import RightArrow from '../../../shared/components/Icon/components/Right4';
import { colors } from '../../../shared/settings';

interface Props {
    onClick: () => void;
    disabled: boolean;
    className?: string;
}

export const buttonHoverStyle = colors99dUi.withAlpha(colors.grey800, 0.4);

const StyledButton = styled.button`
    height: 110px;
    width: 55px;
    z-index: 2;
    border: none;
    font-size: 1.5em;
    color: ${colors.white};
    background-color: ${colors99dUi.withAlpha(colors.grey800, 0.2)};
    transition: all 250ms ease-in-out;
    outline: none;

    &[disabled] {
        opacity: 0;
    }
`;

const StyledLeftButton = styled(StyledButton)`
    border-bottom-right-radius: 55px;
    border-top-right-radius: 55px;
`;

const StyledRightButton = styled(StyledButton)`
    border-bottom-left-radius: 55px;
    border-top-left-radius: 55px;
`;

export const LeftButton = ({ onClick, disabled, ...props }: Props) => (
    <StyledLeftButton
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={__('scroll left')}
        {...props}
    >
        <LeftArrow />
    </StyledLeftButton>
);

export const RightButton = ({ onClick, disabled, ...props }: Props) => (
    <StyledRightButton
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={__('scroll right')}
        {...props}
    >
        <RightArrow />
    </StyledRightButton>
);
